import { useEffect, useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";

export const useCategories = async () => {
  const [categories, setCategories] = useState<any[]>([]);

  const gf = new GiphyFetch("xXAOGlcYvoC74JKasY0CG4WlbrRR0o2p");
  const fetchedCategories = await gf.categories();
  setCategories(fetchedCategories.data);

  return fetchedCategories
};